import agencyRoutes from './routes/agencyRoutes';
import backofficeRoutes from './routes/backofficeRoutes';
import clientRoutes from './routes/clientRoutes';
import commonRoutes from './routes/commonRoutes';
import dcraInspectionRoutes from './routes/dcraInspectionRoutes';
import { elevatorsRoutes } from './routes/elevatorsRoutes';
import inspectorRoutes from './routes/inspectorRoutes';

const routes = [
  ...agencyRoutes,
  ...clientRoutes,
  ...elevatorsRoutes,
  ...dcraInspectionRoutes,
  ...inspectorRoutes,
  ...backofficeRoutes,
  ...commonRoutes,
];

export default routes;
